import { NgOptimizedImage } from '@angular/common';
import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterLink } from '@angular/router';
import { LoggerService } from '../../services/logger/logger-service/logger.service';
import { ScreenSizeService } from '../../services/screen-size-service/screen-size.service';
import { NavComponent } from '../nav/nav.component';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../auth/user-service/user.service';
import { AppMsalAuthService } from '../../auth/authentication-service/app-msal-auth.service';

/**
 * Header containing responsive nav menu.
 */
@Component({
    selector: 'app-header',
    imports: [NgOptimizedImage, MatButtonModule, MatMenuModule, MatIconModule, NavComponent, RouterLink],
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './header.component.css',
})
export class HeaderComponent {
    isModulePage = input(false);

    // Injectables
    protected authService = inject(AppMsalAuthService);
    logger = inject(LoggerService);
    screenSizeService = inject(ScreenSizeService);
    router = inject(Router);

    // Signals
    screenSize = this.screenSizeService.screenSize;

    protected readonly environment = environment;
}
